import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { Markdown } from "components";
import { useAnchor } from "hooks";
import { Stats4Content } from "types/graphql/generated";

interface Props {
  content: Stats4Content;
}

const Stats4: VFC<Props> = withErrorBoundary(({ content: { stats4Title, stats4Award } }) => {
  useAnchor("stats4");

  return (
    <StyledStats4>
      <div className="stats4 Content">
        <h2 className="Stats4__title Font_40_48_600">{stats4Title}</h2>
        <ul className="Stats4__cards">
          {stats4Award.map(({ stats4AwardName, stats4AwardEvent }) => (
            <li key={stats4AwardName} className="Stats4__card">
              <h3 className="Stats4__cardTitle Font_18_26_600">{stats4AwardEvent}</h3>
              <Markdown className="Stats4__awardName Color_secondary Font_24_32_450">{stats4AwardName}</Markdown>
            </li>
          ))}
        </ul>
      </div>
    </StyledStats4>
  );
}, {});

const StyledStats4 = styled.section`
  background: ${({ theme }) => theme.colors.coral["05"]};
  margin-top: -64px;
  padding-top: 64px;

  .Content {
    display: flex;
  }

  .Stats4__title {
    width: 318px;
  }

  .Stats4__cards {
    flex-grow: 1;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 40px 32px;
  }

  .Stats4__cardTitle,
  .Stats4__awardName {
    max-width: 247px;
  }

  .Stats4__awardName {
    margin-top: 4px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    .Content {
      justify-content: space-between;
    }

    .Stats4__title {
      width: 152px;
    }

    .Stats4__cards {
      flex-grow: 0;
      grid-template-columns: repeat(2, 214px);
      margin-left: 112px;
    }

    .Stats4__cardTitle,
    .Stats4__awardName {
      max-width: 100%;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .Content {
      flex-direction: column;
    }

    .Stats4__cards {
      grid-template-columns: 1fr;
      margin-top: 42px;
      margin-left: 0;
    }
  }
`;

gql`
  fragment Stats4Content on ComponentStatsStats4 {
    stats4Title
    stats4Award {
      stats4AwardName
      stats4AwardEvent
    }
  }
`;

export { Stats4 };
export type { Props as Stats4Props };
